import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { NavigationTabs } from '~components/LayoutComponents/NavigationTabs';
import { ROUTES } from '~router/routePaths';

const DEFAULT_NAV_ITEMS = [
  {
    title: 'Company',
    link: 'companies',
  },
  {
    title: 'Users',
    link: 'users',
  },
  {
    title: 'Connections',
    link: 'connections',
  },
  { title: 'Accounts', link: 'accounts' },
];

export const Admin = () => {
  const theme = useTheme();

  const navItems = useMemo(() => {
    const additionalItems = [];

    additionalItems.push({
      title: t('administration.managed_companies.section_title'),
      link: ROUTES.admin.managedCompanies,
    });

    additionalItems.push({
      title: t('administration.report_settings.section_title'),
      link: ROUTES.admin.reportSettings,
    });

    additionalItems.push({
      title: t('administration.export_renderers.section_title'),
      link: ROUTES.admin.exportRenderers,
    });

    additionalItems.push({
      title: t('administration.map_files.section_title'),
      link: ROUTES.admin.mapFiles,
    });

    additionalItems.push({
      title: t('admin.geo.tab_title'),
      link: ROUTES.admin.geo,
    });

    additionalItems.push({
      title: t('administration.utilities.section_title'),
      link: ROUTES.admin.utilities,
    });

    return DEFAULT_NAV_ITEMS.concat(additionalItems);
  }, []);

  return (
    <>
      {/* The full-width divider lives on this container, not on the tabs Box
          (which hugs its content), so the line spans the page without turning
          the empty remainder of the row into a dead-click target. */}
      <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}`, mt: 2 }}>
        <NavigationTabs navItems={navItems} />
      </Box>

      <Box sx={{ py: 4 }}>
        <Outlet />
      </Box>
    </>
  );
};
